// visibilidadSesion.js — ¿Esta sección se muestra a quien está mirando?
//
// `config.mostrar_si`:
//   undefined | 'siempre' → siempre
//   'logueado'            → solo con sesión iniciada
//   'invitado'            → solo sin sesión
//
// Vive aparte de `SectionRenderer` porque el footer global (`layout/Footer.js`)
// necesita la misma regla para elegir entre varios pies configurados.
export const seccionVisibleParaSesion = (config, user) => {
  const modo = config?.mostrar_si;
  if (modo === 'logueado') return !!user;
  if (modo === 'invitado') return !user;
  return true;
};

// De una lista de secciones del mismo tipo, la que le toca a esta persona: la
// primera que case con su sesión. Así un proyecto puede tener un pie para
// visitantes y otro para quien ya entró.
export const elegirPorSesion = (secciones = [], user) => {
  const validas = (secciones || []).filter(s => s && s.visible !== false);
  return validas.find(s => seccionVisibleParaSesion(s.config, user)) || null;
};

export default seccionVisibleParaSesion;
